import React from 'react';
import './app-header.scss';
import { Header } from "@ingka-group-digital/cwds-react-header";
import '@ingka/avatar/style.scss';
import '@ingka/button/style.scss';
import '@ingka/focus/style.scss';
import '@ingka/modal/style.scss';

export const AppHeader: React.FC = () => {

  return (
      <Header
        title="Market Campaign Tool"
        isAppSwitcherShown={false}
        isShowingBottomNav={false}
        headerNavMode={'HEADER_LINKS'}
        navItems={[
          {
            href: '#/',
            label: 'Dashboard'
          },
        ]}
      />
  )
}
export default AppHeader;